// options.js
export const colorOptions = [
  { value: "1", label: "1", price: 0 },
  { value: "1b", label: "1B", price: 0 },
  { value: "2", label: "2", price: 0 },
  { value: "27", label: "27", price: 10 },
  { value: "30", label: "30", price: 10 },
  { value: "custom", label: "Custom Color", price: 20 },
];

export const lengthOptions = [
  { value: "mid-back", label: "Mid-back", price: 0 },
  { value: "waist", label: "Waist", price: 50 },
  { value: "butt", label: "Butt", price: 100 },
  { value: "knee", label: "Knee", price: 200 },
];

export const sizeOptions = [
  { value: "medium", label: "Medium", price: 0 },
  { value: "small-medium", label: "Small-medium", price: 20 },
  { value: "small", label: "Small", price: 50 },
  { value: "extra-small", label: "Extra small", price: 100 },
];